import React from "react";
import styles from "./GradientBorder.module.css";

type GradientBorderProps = {
  children: React.ReactNode;
  borderRadius?: number;
};

/** If you're using a DIFFERENT background color in the children, make sure you add this to your children wrapper:
 * border-radius: borderRadius - 1px;
 * For example, if your button has 3px border-radius, you want to use <GradientBorder borderRadius={4}>
 */
export function GradientBorder({
  children,
  borderRadius = 10,
}: GradientBorderProps) {
  return (
    <div
      className={styles.gradientBorder}
      style={{ borderRadius: `${borderRadius}px` }}
    >
      <div
        className={styles.gradientBorderContent}
        style={{ borderRadius: `${borderRadius - 1}px` }}
      >
        {children}
      </div>
    </div>
  );
}
